import { useEffect } from 'react';

/**
 *
 * This hook prevents the page from scrolling when interacting with the sticky component by adding touch event listeners and cleaning them up on unmount.
 * @param componentId
 */
export const usePreventScrollOnStickyContent = (componentId: string) => {
  useEffect(() => {
    const fixedComponent = document.querySelector(`#${componentId}`);
    const preventScroll = (e: Event) => {
      e.preventDefault();
    };

    if (fixedComponent) {
      fixedComponent.addEventListener('touchmove', preventScroll, { passive: false });
    }

    return () => {
      if (fixedComponent) {
        fixedComponent.removeEventListener('touchmove', preventScroll);
      }
    };
  }, [componentId]);
};
